import React, { Fragment, FunctionComponent } from 'react';
import { WPSimpleArticle } from 'types/articles';
import { WPAcfOfferItem } from 'types/acf';
import { ApplicationCard, OfferDescription } from 'components/containers';
import { Block, BlockContent } from 'components/elements';
import styles from './OfferItem.module.scss';

interface OwnProps {
  data: WPSimpleArticle<WPAcfOfferItem>;
}

type OfferItemProps = JSX.IntrinsicElements['div'] & OwnProps;

const OfferItem: FunctionComponent<OfferItemProps> = props => {
  const { data: offerItem } = props;
  const {
    acf: { card },
  } = offerItem || {};

  return (
    <Fragment>
      <Block id="article" data-module="article">
        <BlockContent direction="row" className={styles.container}>
          <div className={styles.article}>
            <OfferDescription data={offerItem} />
          </div>
          <div className={styles.sidebar}>
            <ApplicationCard data={card} />
          </div>
        </BlockContent>
      </Block>
    </Fragment>
  );
};

export default OfferItem;
